import LegalContentRenderer from '../components/LegalContentRenderer';
import { termsContent } from '../mock/legalContent';

const TermsConditions = () => <LegalContentRenderer content={termsContent} />;

export default TermsConditions;
